export const convertToMax = (number, max) => {
	const numberLength = number.toString().length;
	const maxLength = max.toString().length;
	if (numberLength < maxLength) {
		return '0'.repeat(maxLength - numberLength) + number.toString();
	}

	return number;
};

export const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getStringColumns = () => [
	'original_title',
	'original_language',
	'overview',
	'poster_path',
	'tagline',
	'genres',
];
